module.exports = __webpack_public_path__ + "img/sicon_01.d371dc3e.png";